// Containers
import DiskContainer from "containers/molecules/DiskContainer";
import ButtonContainer from "containers/atoms/ButtonContainer";
import WheelFrameContainer from "containers/molecules/WheelFrameContainer";
import WheelDesignContainer from "containers/organisms/WheelDesignContainer";

// Helpers
import { wheelSetClass } from "helpers/class";

// Types
import { WheelType } from "types/Wheel";

import "./styles.sass";

type WheelProps = {
  idle: boolean;
  type: WheelType;
};

const Wheel = (props: WheelProps) => {
  const { idle, type } = props;

  return (
    <div className={wheelSetClass("Wheel", type)}>
      <WheelDesignContainer />
      <div className={wheelSetClass("Wheel__scoreboard", type, "", idle)}>
        <DiskContainer />
      </div>
      <WheelFrameContainer />
      <ButtonContainer />
    </div>
  );
};

export default Wheel;
